import React, { useCallback, useEffect, useRef } from "react";
import R from "ramda";
import { any, shape, array } from "prop-types";
import useFetchJson from "../../common/useFetchJson.js";
import useSearchValues from "../../common/routing/useSearchValues.js";
import * as SightMap from "./sightmap-api.js";
import { useHistory } from "react-router-dom";

import Loading from "../Loading/Loading.jsx";

const propTypes = {
  scrollToRef: shape({
    current: any,
  }),
  floors: array,
};

const MapView = props => {
  const { floors } = props;
  const embed = useRef(null);
  const history = useHistory();
  const { apiQueryString, getLocationFor, searchValues } = useSearchValues();
  const { floors: floorsUrlValue } = searchValues;
  const domainProtocol = window.location.protocol
  const domainUrl = window.location.hostname;
  const unitsApiUrl = `${domainProtocol}//${domainUrl}/api/v1/units/all/${apiQueryString}`;
  const unitsResponse = useFetchJson(unitsApiUrl, { method: "GET" });
  const isLoading = unitsResponse.isLoading;
  const items = R.pathOr([], ["data", "items"], unitsResponse);
  const embedCode = R.pathOr(null, ["data", "sightmapEmbedId"], unitsResponse);

  const getExternalId = useCallback(
    id => {
      return R.compose(
        R.prop("externalId"),
        R.find(R.propEq("id", id)),
      )(floors);
    },
    [floors],
  );

  const getFloorId = useCallback(
    exId => {
      return R.compose(
        R.unless(R.isNil, R.toString),
        R.prop("id"),
        R.find(R.propEq("externalId", Number(exId))),
      )(floors);
    },
    [floors],
  );

  const updateFloorInMap = useCallback(() => {
    ////do we need to do this?
    // if (embed.current && floorsUrlValue) {
    //   embed.current.getFloor(id => {
    //     if (getFloorId(id) !== floorsUrlValue) {
    //       embed.current.setFloor(getExternalId(Number(floorsUrlValue)));
    //     }
    //   });
    // }
  }, [floorsUrlValue, getExternalId, getFloorId]);

  // initially set up the map
  useEffect(() => {
    if (!embed.current && embedCode) {
      const sightmapEmbed = new SightMap.Embed("smid");
      const onReady = () => {
        sightmapEmbed.disableUI(["filters"]);
        sightmapEmbed.setUnitIdMatches(R.map(R.prop("id"), items));
        updateFloorInMap(); // load with the selected floor
      };
      sightmapEmbed.on("ready", () => {
        onReady();
      });
      embed.current = sightmapEmbed;
      return () => {
        //checking for sightmapEmbed for ie11 bug
        if (sightmapEmbed) {
          sightmapEmbed.off("ready", () => {
            onReady();
          });
        }
      };
    }
  }, [embedCode, items]); /* eslint-disable-line react-hooks/exhaustive-deps */

  // update the map floor if the floor value in the url changes
  // (user changes filter, or pushed back button, etc)
  useEffect(() => {
    //   if (embedCode) {
    //     updateFloorInMap();
    //   }
  }, [updateFloorInMap, embedCode]);

  // update the url when the user changes the floor in the map
  useEffect(() => {
    if (embed.current) {
      //do we need to do this?
      // const onFloorChange = event => {
      //   embed.current.getFloor(id => {
      //     if (getFloorId(Number(id)) !== Number(floorsUrlValue)) {
      //       history.push(getLocationFor({ floors: getFloorId(Number(id)) }));
      //     }
      //   });
      // };

      //set url to api floor
      // embed.current.on("metrics.unitMatches.change", onFloorChange);

      return () => {
        // embed.current.off("metrics.unitMatches.change", onFloorChange);
      };
    }
  }, [getExternalId, getFloorId, getLocationFor, history, floorsUrlValue]);

  //updates units when the user updates the filters
  useEffect(() => {
    if (embedCode) {
      if (items.length > 0) {
        embed.current.setUnitIdMatches(R.map(R.prop("id"), items));
      }
    }
  }, [items, embedCode]);

  return (
    <div>
      {(!isLoading && embedCode) &&
        <div style={{ height: "70vh" }}>
          <iframe
            id="js-sitemap"
            width="100%"
            height="800"
            style={{ height: "70vh" }}
            src={`https://sightmap.com/embed/${embedCode}?enable_api=1&origin=${window.location.origin}`}
            frameBorder="0"
            title="engrainEmbed"
          />
        </div>
      }
    </div>
  );
};

MapView.propTypes = propTypes;
export default MapView;
